module.exports = __webpack_public_path__ + "img/UHF-DVS-50.b7a75ea8.png";